import {
  __commonJS,
  __toESM,
  checkToken,
  init_esm_shims,
  isUserToken
} from "./chunk-C4UH2P2Q.js";

// ../../node_modules/css-element-queries/src/ResizeSensor.js
var require_ResizeSensor = __commonJS({
  "../../node_modules/css-element-queries/src/ResizeSensor.js"(exports, module2) {
    "use strict";
    init_esm_shims();
    (function(root, factory) {
      if (typeof define === "function" && define.amd) {
        define(factory);
      } else if (typeof exports === "object") {
        module2.exports = factory();
      } else {
        root.ResizeSensor = factory();
      }
    })(typeof window !== "undefined" ? window : exports, function() {
      if (typeof window === "undefined") {
        return null;
      }
      var globalWindow = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
      var requestAnimationFrame = globalWindow.requestAnimationFrame || globalWindow.mozRequestAnimationFrame || globalWindow.webkitRequestAnimationFrame || function(fn) {
        return globalWindow.setTimeout(fn, 20);
      };
      var cancelAnimationFrame = globalWindow.cancelAnimationFrame || globalWindow.mozCancelAnimationFrame || globalWindow.webkitCancelAnimationFrame || function(timer) {
        globalWindow.clearTimeout(timer);
      };
      function forEachElement(elements, callback) {
        var elementsType = Object.prototype.toString.call(elements);
        var isCollectionTyped = "[object Array]" === elementsType || "[object NodeList]" === elementsType || "[object HTMLCollection]" === elementsType || "[object Object]" === elementsType || "undefined" !== typeof jQuery && elements instanceof jQuery || "undefined" !== typeof Elements && elements instanceof Elements;
        var i = 0, j = elements.length;
        if (isCollectionTyped) {
          for (; i < j; i++) {
            callback(elements[i]);
          }
        } else {
          callback(elements);
        }
      }
      function getElementSize(element) {
        if (!element.getBoundingClientRect) {
          return {
            width: element.offsetWidth,
            height: element.offsetHeight
          };
        }
        var rect = element.getBoundingClientRect();
        return {
          width: Math.round(rect.width),
          height: Math.round(rect.height)
        };
      }
      function setStyle(element, style) {
        Object.keys(style).forEach(function(key) {
          element.style[key] = style[key];
        });
      }
      var ResizeSensor2 = function(element, callback) {
        var lastAnimationFrameForInvisibleCheck = 0;
        function EventQueue() {
          var q = [];
          this.add = function(ev) {
            q.push(ev);
          };
          var i, j;
          this.call = function(sizeInfo) {
            for (i = 0, j = q.length; i < j; i++) {
              q[i].call(this, sizeInfo);
            }
          };
          this.remove = function(ev) {
            var newQueue = [];
            for (i = 0, j = q.length; i < j; i++) {
              if (q[i] !== ev)
                newQueue.push(q[i]);
            }
            q = newQueue;
          };
          this.length = function() {
            return q.length;
          };
        }
        function attachResizeEvent(element2, resized) {
          if (!element2)
            return;
          if (element2.resizedAttached) {
            element2.resizedAttached.add(resized);
            return;
          }
          element2.resizedAttached = new EventQueue();
          element2.resizedAttached.add(resized);
          element2.resizeSensor = document.createElement("div");
          element2.resizeSensor.dir = "ltr";
          element2.resizeSensor.className = "resize-sensor";
          var style = {
            pointerEvents: "none",
            position: "absolute",
            left: "0px",
            top: "0px",
            right: "0px",
            bottom: "0px",
            overflow: "hidden",
            zIndex: "-1",
            visibility: "hidden",
            maxWidth: "100%"
          };
          var styleChild = {
            position: "absolute",
            left: "0px",
            top: "0px",
            transition: "0s"
          };
          setStyle(element2.resizeSensor, style);
          var expand = document.createElement("div");
          expand.className = "resize-sensor-expand";
          setStyle(expand, style);
          var expandChild = document.createElement("div");
          setStyle(expandChild, styleChild);
          expand.appendChild(expandChild);
          var shrink = document.createElement("div");
          shrink.className = "resize-sensor-shrink";
          setStyle(shrink, style);
          var shrinkChild = document.createElement("div");
          setStyle(shrinkChild, styleChild);
          setStyle(shrinkChild, { width: "200%", height: "200%" });
          shrink.appendChild(shrinkChild);
          element2.resizeSensor.appendChild(expand);
          element2.resizeSensor.appendChild(shrink);
          element2.appendChild(element2.resizeSensor);
          var computedStyle = window.getComputedStyle(element2);
          var position = computedStyle ? computedStyle.getPropertyValue("position") : null;
          if ("absolute" !== position && "relative" !== position && "fixed" !== position && "sticky" !== position) {
            element2.style.position = "relative";
          }
          var dirty = false;
          var rafId = 0;
          var size = getElementSize(element2);
          var lastWidth = 0;
          var lastHeight = 0;
          var initialHiddenCheck = true;
          lastAnimationFrameForInvisibleCheck = 0;
          var resetExpandShrink = function() {
            var width = element2.offsetWidth;
            var height = element2.offsetHeight;
            expandChild.style.width = width + 10 + "px";
            expandChild.style.height = height + 10 + "px";
            expand.scrollLeft = width + 10;
            expand.scrollTop = height + 10;
            shrink.scrollLeft = width + 10;
            shrink.scrollTop = height + 10;
          };
          var reset = function() {
            if (initialHiddenCheck) {
              var invisible = element2.offsetWidth === 0 && element2.offsetHeight === 0;
              if (invisible) {
                if (!lastAnimationFrameForInvisibleCheck) {
                  lastAnimationFrameForInvisibleCheck = requestAnimationFrame(function() {
                    lastAnimationFrameForInvisibleCheck = 0;
                    reset();
                  });
                }
                return;
              } else {
                initialHiddenCheck = false;
              }
            }
            resetExpandShrink();
          };
          element2.resizeSensor.resetSensor = reset;
          var onResized = function() {
            rafId = 0;
            if (!dirty)
              return;
            lastWidth = size.width;
            lastHeight = size.height;
            if (element2.resizedAttached) {
              element2.resizedAttached.call(size);
            }
          };
          var onScroll = function() {
            size = getElementSize(element2);
            dirty = size.width !== lastWidth || size.height !== lastHeight;
            if (dirty && !rafId) {
              rafId = requestAnimationFrame(onResized);
            }
            reset();
          };
          var addEvent = function(el, name, cb) {
            if (el.attachEvent) {
              el.attachEvent("on" + name, cb);
            } else {
              el.addEventListener(name, cb);
            }
          };
          addEvent(expand, "scroll", onScroll);
          addEvent(shrink, "scroll", onScroll);
          lastAnimationFrameForInvisibleCheck = requestAnimationFrame(function() {
            lastAnimationFrameForInvisibleCheck = 0;
            reset();
          });
        }
        forEachElement(element, function(elem) {
          attachResizeEvent(elem, callback);
        });
        this.detach = function(ev) {
          if (!lastAnimationFrameForInvisibleCheck) {
            cancelAnimationFrame(lastAnimationFrameForInvisibleCheck);
            lastAnimationFrameForInvisibleCheck = 0;
          }
          ResizeSensor2.detach(element, ev);
        };
        this.reset = function() {
          element.resizeSensor.resetSensor();
        };
      };
      ResizeSensor2.reset = function(element) {
        forEachElement(element, function(elem) {
          elem.resizeSensor.resetSensor();
        });
      };
      ResizeSensor2.detach = function(element, ev) {
        forEachElement(element, function(elem) {
          if (!elem)
            return;
          if (elem.resizedAttached && typeof ev === "function") {
            elem.resizedAttached.remove(ev);
            if (elem.resizedAttached.length())
              return;
          }
          if (elem.resizeSensor) {
            if (elem.contains(elem.resizeSensor)) {
              elem.removeChild(elem.resizeSensor);
            }
            delete elem.resizeSensor;
            delete elem.resizedAttached;
          }
        });
      };
      if (typeof MutationObserver !== "undefined") {
        var observer = new MutationObserver(function(mutations) {
          for (var i in mutations) {
            if (mutations.hasOwnProperty(i)) {
              var items = mutations[i].addedNodes;
              for (var j = 0; j < items.length; j++) {
                if (items[j].resizeSensor) {
                  ResizeSensor2.reset(items[j]);
                }
              }
            }
          }
        });
        document.addEventListener("DOMContentLoaded", function(event) {
          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        });
      }
      return ResizeSensor2;
    });
  }
});

// ../../node_modules/css-element-queries/src/ElementQueries.js
var require_ElementQueries = __commonJS({
  "../../node_modules/css-element-queries/src/ElementQueries.js"(exports, module2) {
    "use strict";
    init_esm_shims();
    (function(root, factory) {
      if (typeof define === "function" && define.amd) {
        define(["./ResizeSensor.js"], factory);
      } else if (typeof exports === "object") {
        module2.exports = factory(require_ResizeSensor());
      } else {
        root.ElementQueries = factory(root.ResizeSensor);
        root.ElementQueries.listen();
      }
    })(typeof window !== "undefined" ? window : exports, function(ResizeSensor2) {
      var ElementQueries = function() {
        var cssStyleElement;
        var allQueries = {};
        var idToSelectorMapping = [];
        function getEmSize(element) {
          if (!element) {
            element = document.documentElement;
          }
          var fontSize = window.getComputedStyle(element, null).fontSize;
          return parseFloat(fontSize) || 16;
        }
        function getElementSize(element) {
          if (!element.getBoundingClientRect) {
            return {
              width: element.offsetWidth,
              height: element.offsetHeight
            };
          }
          var rect = element.getBoundingClientRect();
          return {
            width: Math.round(rect.width),
            height: Math.round(rect.height)
          };
        }
        function convertToPx(element, value) {
          var numbers = value.split(/\d/);
          var units = numbers[numbers.length - 1];
          value = parseFloat(value);
          switch (units) {
            case "px":
              return value;
            case "em":
              return value * getEmSize(element);
            case "rem":
              return value * getEmSize();
            case "vw":
              return value * document.documentElement.clientWidth / 100;
            case "vh":
              return value * document.documentElement.clientHeight / 100;
            case "vmin":
            case "vmax":
              var vw = document.documentElement.clientWidth / 100;
              var vh = document.documentElement.clientHeight / 100;
              var chooser = Math[units === "vmin" ? "min" : "max"];
              return value * chooser(vw, vh);
            default:
              return value;
          }
        }
        function SetupInformation(element, id) {
          this.element = element;
          var key, option, elementSize, value, actualValue, attrValues, attrValue, attrName;
          var attributes = ["min-width", "min-height", "max-width", "max-height"];
          this.call = function() {
            elementSize = getElementSize(this.element);
            attrValues = {};
            for (key in allQueries[id]) {
              if (!allQueries[id].hasOwnProperty(key)) {
                continue;
              }
              option = allQueries[id][key];
              value = convertToPx(this.element, option.value);
              actualValue = option.property === "width" ? elementSize.width : elementSize.height;
              attrName = option.mode + "-" + option.property;
              attrValue = "";
              if (option.mode === "min" && actualValue >= value) {
                attrValue += option.value;
              }
              if (option.mode === "max" && actualValue <= value) {
                attrValue += option.value;
              }
              if (!attrValues[attrName])
                attrValues[attrName] = "";
              if (attrValue && -1 === (" " + attrValues[attrName] + " ").indexOf(" " + attrValue + " ")) {
                attrValues[attrName] += " " + attrValue;
              }
            }
            for (var k in attributes) {
              if (!attributes.hasOwnProperty(k))
                continue;
              if (attrValues[attributes[k]]) {
                this.element.setAttribute(attributes[k], attrValues[attributes[k]].substr(1));
              } else {
                this.element.removeAttribute(attributes[k]);
              }
            }
          };
        }
        function setupElement(element, id) {
          if (!element.elementQueriesSetupInformation) {
            element.elementQueriesSetupInformation = new SetupInformation(element, id);
          }
          if (!element.elementQueriesSensor) {
            element.elementQueriesSensor = new ResizeSensor2(element, function() {
              element.elementQueriesSetupInformation.call();
            });
          }
        }
        function queueQuery(selector, mode, property, value) {
          if (typeof allQueries[selector] === "undefined") {
            allQueries[selector] = [];
            var id = idToSelectorMapping.length;
            cssStyleElement.innerHTML += "\n" + selector + " {animation: 0.1s element-queries;}";
            cssStyleElement.innerHTML += "\n" + selector + " > .resize-sensor {min-width: " + id + "px;}";
            idToSelectorMapping.push(selector);
          }
          allQueries[selector].push({
            mode,
            property,
            value
          });
        }
        function getQuery(container) {
          var query;
          if (document.querySelectorAll)
            query = container ? container.querySelectorAll.bind(container) : document.querySelectorAll.bind(document);
          if (!query && "undefined" !== typeof $$)
            query = $$;
          if (!query && "undefined" !== typeof jQuery)
            query = jQuery;
          if (!query) {
            throw "No document.querySelectorAll, jQuery or Mootools's $$ found.";
          }
          return query;
        }
        function findElementQueriesElements(container) {
          var query = getQuery(container);
          for (var selector in allQueries)
            if (allQueries.hasOwnProperty(selector)) {
              var elements = query(selector, container);
              for (var i = 0, j = elements.length; i < j; i++) {
                setupElement(elements[i], selector);
              }
            }
        }
        function attachResponsiveImage(element) {
          var children = [];
          var rules = [];
          var sources = [];
          var defaultImageId = 0;
          var lastActiveImage = -1;
          var loadedImages = [];
          for (var i in element.children) {
            if (!element.children.hasOwnProperty(i))
              continue;
            if (element.children[i].tagName && element.children[i].tagName.toLowerCase() === "img") {
              children.push(element.children[i]);
              var minWidth = element.children[i].getAttribute("min-width") || element.children[i].getAttribute("data-min-width");
              var src = element.children[i].getAttribute("data-src") || element.children[i].getAttribute("url");
              sources.push(src);
              var rule = {
                minWidth
              };
              rules.push(rule);
              if (!minWidth) {
                defaultImageId = children.length - 1;
                element.children[i].style.display = "block";
              } else {
                element.children[i].style.display = "none";
              }
            }
          }
          lastActiveImage = defaultImageId;
          function check() {
            var imageToDisplay = false, i2;
            for (i2 in children) {
              if (!children.hasOwnProperty(i2))
                continue;
              if (rules[i2].minWidth) {
                if (element.offsetWidth > rules[i2].minWidth) {
                  imageToDisplay = i2;
                }
              }
            }
            if (!imageToDisplay) {
              imageToDisplay = defaultImageId;
            }
            if (lastActiveImage !== imageToDisplay) {
              if (!loadedImages[imageToDisplay]) {
                var image = new Image();
                image.onload = function() {
                  children[imageToDisplay].src = sources[imageToDisplay];
                  children[lastActiveImage].style.display = "none";
                  children[imageToDisplay].style.display = "block";
                  loadedImages[imageToDisplay] = true;
                  lastActiveImage = imageToDisplay;
                };
                image.src = sources[imageToDisplay];
              } else {
                children[lastActiveImage].style.display = "none";
                children[imageToDisplay].style.display = "block";
                lastActiveImage = imageToDisplay;
              }
            } else {
              children[imageToDisplay].src = sources[imageToDisplay];
            }
          }
          element.resizeSensorInstance = new ResizeSensor2(element, check);
          check();
        }
        function findResponsiveImages() {
          var query = getQuery();
          var elements = query("[data-responsive-image],[responsive-image]");
          for (var i = 0, j = elements.length; i < j; i++) {
            attachResponsiveImage(elements[i]);
          }
        }
        var regex = /,?[\s\t]*([^,\n]*?)((?:\[[\s\t]*?(?:min|max)-(?:width|height)[\s\t]*?[~$\^]?=[\s\t]*?"[^"]*?"[\s\t]*?])+)([^,\n\s\{]*)/mgi;
        var attrRegex = /\[[\s\t]*?(min|max)-(width|height)[\s\t]*?[~$\^]?=[\s\t]*?"([^"]*?)"[\s\t]*?]/mgi;
        function extractQuery(css2) {
          var match, smatch, attrs, attrMatch;
          css2 = css2.replace(/'/g, '"');
          while (null !== (match = regex.exec(css2))) {
            smatch = match[1] + match[3];
            attrs = match[2];
            while (null !== (attrMatch = attrRegex.exec(attrs))) {
              queueQuery(smatch, attrMatch[1], attrMatch[2], attrMatch[3]);
            }
          }
        }
        function readRules(rules) {
          var selector = "";
          if (!rules) {
            return;
          }
          if ("string" === typeof rules) {
            rules = rules.toLowerCase();
            if (-1 !== rules.indexOf("min-width") || -1 !== rules.indexOf("max-width")) {
              extractQuery(rules);
            }
          } else {
            for (var i = 0, j = rules.length; i < j; i++) {
              if (1 === rules[i].type) {
                selector = rules[i].selectorText || rules[i].cssText;
                if (-1 !== selector.indexOf("min-height") || -1 !== selector.indexOf("max-height")) {
                  extractQuery(selector);
                } else if (-1 !== selector.indexOf("min-width") || -1 !== selector.indexOf("max-width")) {
                  extractQuery(selector);
                }
              } else if (4 === rules[i].type) {
                readRules(rules[i].cssRules || rules[i].rules);
              } else if (3 === rules[i].type) {
                if (rules[i].styleSheet.hasOwnProperty("cssRules")) {
                  readRules(rules[i].styleSheet.cssRules);
                }
              }
            }
          }
        }
        var defaultCssInjected = false;
        this.init = function() {
          var animationStart = "animationstart";
          if (typeof document.documentElement.style["webkitAnimationName"] !== "undefined") {
            animationStart = "webkitAnimationStart";
          } else if (typeof document.documentElement.style["MozAnimationName"] !== "undefined") {
            animationStart = "mozanimationstart";
          } else if (typeof document.documentElement.style["OAnimationName"] !== "undefined") {
            animationStart = "oanimationstart";
          }
          document.body.addEventListener(animationStart, function(e) {
            var element = e.target;
            var styles = element && window.getComputedStyle(element, null);
            var animationName = styles && styles.getPropertyValue("animation-name");
            var requiresSetup = animationName && -1 !== animationName.indexOf("element-queries");
            if (requiresSetup) {
              element.elementQueriesSensor = new ResizeSensor2(element, function() {
                if (element.elementQueriesSetupInformation) {
                  element.elementQueriesSetupInformation.call();
                }
              });
              var sensorStyles = window.getComputedStyle(element.resizeSensor, null);
              var id = sensorStyles.getPropertyValue("min-width");
              id = parseInt(id.replace("px", ""));
              setupElement(e.target, idToSelectorMapping[id]);
            }
          });
          if (!defaultCssInjected) {
            cssStyleElement = document.createElement("style");
            cssStyleElement.type = "text/css";
            cssStyleElement.innerHTML = "[responsive-image] > img, [data-responsive-image] {overflow: hidden; padding: 0; } [responsive-image] > img, [data-responsive-image] > img {width: 100%;}";
            cssStyleElement.innerHTML += "\n@keyframes element-queries { 0% { visibility: inherit; } }";
            document.getElementsByTagName("head")[0].appendChild(cssStyleElement);
            defaultCssInjected = true;
          }
          for (var i = 0, j = document.styleSheets.length; i < j; i++) {
            try {
              if (document.styleSheets[i].href && 0 === document.styleSheets[i].href.indexOf("file://")) {
                console.warn("CssElementQueries: unable to parse local css files, " + document.styleSheets[i].href);
              }
              readRules(document.styleSheets[i].cssRules || document.styleSheets[i].rules || document.styleSheets[i].cssText);
            } catch (e) {
            }
          }
          findResponsiveImages();
        };
        this.findElementQueriesElements = function(container) {
          findElementQueriesElements(container);
        };
        this.update = function() {
          this.init();
        };
      };
      ElementQueries.update = function() {
        ElementQueries.instance.update();
      };
      ElementQueries.detach = function(element) {
        if (element.elementQueriesSetupInformation) {
          element.elementQueriesSensor.detach();
          delete element.elementQueriesSetupInformation;
          delete element.elementQueriesSensor;
        } else if (element.resizeSensorInstance) {
          element.resizeSensorInstance.detach();
          delete element.resizeSensorInstance;
        }
      };
      ElementQueries.init = function() {
        if (!ElementQueries.instance) {
          ElementQueries.instance = new ElementQueries();
        }
        ElementQueries.instance.init();
      };
      var domLoaded = function(callback) {
        if (document.addEventListener) {
          document.addEventListener("DOMContentLoaded", callback, false);
        } else if (/KHTML|WebKit|iCab/i.test(navigator.userAgent)) {
          var DOMLoadTimer = setInterval(function() {
            if (/loaded|complete/i.test(document.readyState)) {
              callback();
              clearInterval(DOMLoadTimer);
            }
          }, 10);
        } else
          window.onload = callback;
      };
      ElementQueries.findElementQueriesElements = function(container) {
        ElementQueries.instance.findElementQueriesElements(container);
      };
      ElementQueries.listen = function() {
        domLoaded(ElementQueries.init);
      };
      return ElementQueries;
    });
  }
});

// ../../node_modules/css-element-queries/index.js
var require_css_element_queries = __commonJS({
  "../../node_modules/css-element-queries/index.js"(exports, module2) {
    init_esm_shims();
    module2.exports = {
      ResizeSensor: require_ResizeSensor(),
      ElementQueries: require_ElementQueries()
    };
  }
});

// src/index.ts
init_esm_shims();

// src/createIframe.ts
init_esm_shims();
var import_css_element_queries = __toESM(require_css_element_queries(), 1);
function createEvents() {
  const listeners = /* @__PURE__ */ new Map();
  const events = {};
  events.badges = {};
  events.configured = false;
  events.emit = (event, data) => {
    var _a2;
    (_a2 = listeners.get(event)) == null ? void 0 : _a2.forEach((listener) => listener(data));
  };
  events.on = (event, callback) => {
    var _a2;
    if (!listeners.has(event)) {
      listeners.set(event, /* @__PURE__ */ new Set());
    }
    (_a2 = listeners.get(event)) == null ? void 0 : _a2.add(callback);
    return () => {
      var _a3;
      (_a3 = listeners.get(event)) == null ? void 0 : _a3.delete(callback);
    };
  };
  return events;
}
function renderIframe({ events }, {
  rootEl,
  env,
  url,
  token,
  headless,
  disableFit
}, openWindow) {
  const iFrame = document.createElement("iframe");
  iFrame.src = url;
  iFrame.style.display = "block";
  iFrame.style.width = headless ? "0" : "100%";
  iFrame.style.height = headless ? "0" : "100%";
  if (headless) {
    iFrame.style.position = "fixed";
    iFrame.style.top = "-100px";
  }
  window.addEventListener("message", (e) => {
    var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j;
    if (e.origin !== url) {
      return;
    }
    if (e.source !== iFrame.contentWindow) {
      return;
    }
    if (((_a2 = e.data) == null ? void 0 : _a2.type) === "APP_IS_READY") {
      (_b2 = iFrame.contentWindow) == null ? void 0 : _b2.postMessage({ env, initToken: token, headless }, url);
      (_d = iFrame.contentWindow) == null ? void 0 : _d.postMessage(
        { notificationsPermission: (_c = window.Notification) == null ? void 0 : _c.permission },
        url
      );
    } else if (((_e = e.data) == null ? void 0 : _e.type) === "REQUEST_NOTIFICATIONS_PERMISSION") {
      (_f = window.Notification) == null ? void 0 : _f.requestPermission().then(function(permission) {
        var _a3;
        (_a3 = iFrame.contentWindow) == null ? void 0 : _a3.postMessage({ notificationsPermission: permission }, url);
      });
    } else if (((_g = e.data) == null ? void 0 : _g.type) === "BADGES" && ((_h = e.data) == null ? void 0 : _h.badges) !== void 0) {
      const badges = JSON.parse(e.data.badges);
      events.badges = badges;
      events.emit("fogbender.badges", { badges });
      const unreadCount = (() => {
        let isMentionOrDialog = false;
        let count = 0;
        Object.keys(badges).find((roomId) => {
          const badge = badges[roomId];
          if (badge.mentionsCount) {
            isMentionOrDialog = true;
          } else if (badge.count) {
            isMentionOrDialog = badge.roomType === "dialog";
          }
          if (badge.count) {
            count++;
          }
          return isMentionOrDialog;
        });
        return isMentionOrDialog ? -1 : count;
      })();
      events.unreadCount = unreadCount;
      events.emit("fogbender.unreadCount", { unreadCount });
    } else if (((_i = e.data) == null ? void 0 : _i.type) === "NOTIFICATION" && e.data.notification !== void 0 && token !== void 0) {
      if (((_j = window.Notification) == null ? void 0 : _j.permission) === "granted") {
        const { body, roomId } = JSON.parse(e.data.notification);
        const notification = new Notification(token.customerName || "Support", { body });
        notification.onclick = () => {
          var _a3;
          if (headless) {
            openWindow();
          } else {
            window.parent.focus();
            (_a3 = iFrame.contentWindow) == null ? void 0 : _a3.postMessage({ roomIdToOpen: roomId }, url);
          }
        };
      }
    }
  });
  rootEl.append(iFrame);
  function adaptIFrame() {
    if (!rootEl || disableFit) {
      return;
    }
    const height = headless ? 0 : Math.min(window.innerHeight, window.innerHeight - rootEl.getBoundingClientRect().top);
    iFrame.style.height = height + "px";
  }
  adaptIFrame();
  new import_css_element_queries.ResizeSensor(rootEl, adaptIFrame);
  new import_css_element_queries.ResizeSensor(document.body, adaptIFrame);
  window.addEventListener("resize", adaptIFrame);
  return () => {
    iFrame.src = "about:blank";
    rootEl.removeChild(iFrame);
  };
}

// src/floatingWidget.tsx
init_esm_shims();
import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { className as _$className } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { render } from "solid-js/web";
import { createMemo, createSignal } from "solid-js";
import { tw } from "twind";
import { css } from "twind/css";

// src/twind.ts
init_esm_shims();
import { cssomSheet, setup } from "twind";
var sharedSheet = () => {
  const target = document.createElement("style");
  const offset = target.childNodes.length;
  const instances = /* @__PURE__ */ new Set([target]);
  const sheet = {
    target,
    insert: (rule, index) => instances.forEach((instance) => {
      instance.insertBefore(document.createTextNode(rule), instance.childNodes[offset + index]);
    })
  };
  const attach = (root) => {
    const instance = target.cloneNode(true);
    instances.add(instance);
    if (instances.size === 100) {
      console.error("Fogbender: oopsie poopsie, too many instances of sharedSheet");
    }
    root == null ? void 0 : root.appendChild(instance);
  };
  return { sheet, attach };
};
var createSheet = () => {
  let attach = (_root) => {
  };
  const fastCss = (() => {
    try {
      return !!new CSSStyleSheet();
    } catch (e) {
      return false;
    }
  })();
  if (fastCss) {
    const target = new CSSStyleSheet();
    attach = (root) => {
      if (root) {
        root.adoptedStyleSheets = [
          target
        ];
      }
    };
    return { sheet: cssomSheet({ target }), attach };
  } else {
    return sharedSheet();
  }
};
var createTwind = () => {
  const sheet = createSheet();
  setup({
    sheet: sheet.sheet,
    theme: {
      extend: {
        colors: {
          "brand-red-500": "#FA3541"
        },
        fontSize: {
          "2xs": "0.625rem"
        },
        minWidth: {
          "1rem": "1rem"
        },
        minHeight: {
          "1rem": "1rem"
        },
        fill: {
          "white": "#FFF",
          "blue-500": "#3B82F6"
        }
      }
    }
  });
  return sheet;
};
var singletonHolder;
function getTwind() {
  return singletonHolder || (singletonHolder = createTwind());
}
var _a, _b;
if (typeof module === "object" && module.hot) {
  singletonHolder = ((_b = (_a = module.hot) == null ? void 0 : _a.data) == null ? void 0 : _b.singletonHolder) || singletonHolder;
  module.hot.dispose((data) => {
    data.singletonHolder = singletonHolder;
  });
}

// src/floatingWidget.tsx
var _tmpl$ = /* @__PURE__ */ _$template(`<div style="z-index: 9999;"><button title="Customer support"></button></div>`, 4);
var _tmpl$2 = /* @__PURE__ */ _$template(`<div><button></button></div>`, 4);
var _tmpl$3 = /* @__PURE__ */ _$template(`<div></div>`, 2);
var _tmpl$4 = /* @__PURE__ */ _$template(`<div><div></div><div>Customer support</div><div></div></div>`, 8);
var _tmpl$5 = /* @__PURE__ */ _$template(`<div><div></div><div></div><div></div></div>`, 8);
var _tmpl$6 = /* @__PURE__ */ _$template(`<svg width="33" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.999.75 0 24.453 6.999 39.25l7.362-14.797L7 .75Z" fill="#FE346E"></path><path d="m12.684 32.083 3.39 7.166 7.173-14.419L16.073.75l-3.38 11.936 3.706 11.93-3.715 7.467Z" fill="#FF7315"></path><path d="m21.757 32.083 3.39 7.166L32.32 24.83 25.147.75 21.69 12.958l3.589 12.047-3.522 7.078Z" fill="#7E0CF5"></path></svg>`, 8);
var _tmpl$7 = /* @__PURE__ */ _$template(`<svg width="120" height="120" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#a)"><path d="M87.026 33.083c-7.775-9.336-11.662-14.005-15.981-16.273a24.514 24.514 0 0 0-23.33.29c-4.26 2.374-8.055 7.167-15.643 16.753-6.296 7.953-9.443 11.93-10.805 16a24.514 24.514 0 0 0 2.43 20.724c2.266 3.645 6.224 6.767 14.14 13.01 6.218 4.904 9.327 7.356 12.643 8.676a24.515 24.515 0 0 0 17.568.215c3.346-1.238 6.538-3.63 12.922-8.417 8.516-6.385 12.774-9.577 15.167-13.318a24.515 24.515 0 0 0 2.493-21.29c-1.464-4.193-4.844-8.252-11.604-16.37Z" fill="#fff"></path><mask id="b" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="20" y="14" width="81" height="80"><path d="M87.026 33.083c-7.775-9.336-11.662-14.005-15.981-16.273a24.514 24.514 0 0 0-23.33.29c-4.26 2.374-8.055 7.167-15.643 16.753-6.296 7.953-9.443 11.93-10.805 16a24.514 24.514 0 0 0 2.43 20.724c2.266 3.645 6.224 6.767 14.14 13.01 6.218 4.904 9.327 7.356 12.643 8.676a24.515 24.515 0 0 0 17.568.215c3.346-1.238 6.538-3.63 12.922-8.417 8.516-6.385 12.774-9.577 15.167-13.318a24.515 24.515 0 0 0 2.493-21.29c-1.464-4.193-4.844-8.252-11.604-16.37Z" fill="#FE346E"></path></mask><g mask="url(#b)"><path d="M48.094 29 39 59.803l9.094 19.23 9.568-19.23L48.094 29Z" fill="#FE346E"></path><path d="m55.481 69.72 4.404 9.312 9.323-18.738L59.885 29l-4.392 15.512 4.815 15.504-4.827 9.703Z" fill="#FF7315"></path><path d="m67.273 69.72 4.405 9.312L81 60.294 71.678 29l-4.493 15.865 4.664 15.657-4.576 9.197Z" fill="#7E0CF5"></path></g></g><defs><filter id="a" x="0" y="0" width="120" height="120" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="6"></feOffset><feGaussianBlur stdDeviation="10"></feGaussianBlur><feColorMatrix values="0 0 0 0 0.0751563 0 0 0 0 0.113891 0 0 0 0 0.4625 0 0 0 0.15 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2573_3255"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_2573_3255" result="shape"></feBlend></filter></defs></svg>`, 36);
var _tmpl$8 = /* @__PURE__ */ _$template(`<svg width="120" height="120" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#a)"><path d="M87.026 33.083c-7.775-9.336-11.662-14.005-15.981-16.273a24.514 24.514 0 0 0-23.33.29c-4.26 2.374-8.055 7.167-15.643 16.753-6.296 7.953-9.443 11.93-10.805 16a24.514 24.514 0 0 0 2.43 20.724c2.266 3.645 6.224 6.767 14.14 13.01 6.218 4.904 9.327 7.356 12.643 8.676a24.515 24.515 0 0 0 17.568.215c3.346-1.238 6.538-3.63 12.922-8.417 8.516-6.385 12.774-9.577 15.167-13.318a24.515 24.515 0 0 0 2.493-21.29c-1.464-4.193-4.844-8.252-11.604-16.37Z"></path><mask id="b" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="20" y="14" width="81" height="80"><path d="M87.026 33.083c-7.775-9.336-11.662-14.005-15.981-16.273a24.514 24.514 0 0 0-23.33.29c-4.26 2.374-8.055 7.167-15.643 16.753-6.296 7.953-9.443 11.93-10.805 16a24.514 24.514 0 0 0 2.43 20.724c2.266 3.645 6.224 6.767 14.14 13.01 6.218 4.904 9.327 7.356 12.643 8.676a24.515 24.515 0 0 0 17.568.215c3.346-1.238 6.538-3.63 12.922-8.417 8.516-6.385 12.774-9.577 15.167-13.318a24.515 24.515 0 0 0 2.493-21.29c-1.464-4.193-4.844-8.252-11.604-16.37Z" fill="currentColor"></path></mask><g mask="url(#b)"><path d="m41.365 63-1.719-5.6h-.044c.062 1.139.093 1.899.093 2.28V63h-1.352v-7.139h2.06l1.69 5.46h.029l1.792-5.46h2.06V63h-1.41v-3.379c0-.16 0-.343.004-.552.007-.208.03-.761.069-1.66h-.044L42.752 63h-1.387Zm6.23-6.87c0-.485.27-.728.811-.728.54 0 .81.243.81.728 0 .231-.068.412-.205.542-.133.127-.335.19-.605.19-.54 0-.81-.244-.81-.732ZM49.148 63h-1.49v-5.459h1.49V63Zm6.607 0h-1.49v-3.188c0-.394-.07-.689-.21-.884-.14-.199-.362-.298-.669-.298-.416 0-.717.14-.903.42-.185.277-.278.737-.278 1.382V63h-1.49v-5.459h1.138l.2.698h.084a1.56 1.56 0 0 1 .683-.595c.293-.137.625-.206.996-.206.635 0 1.117.173 1.445.518.33.342.494.837.494 1.484V63Zm1.47-6.87c0-.485.27-.728.81-.728s.81.243.81.728c0 .231-.068.412-.205.542-.133.127-.335.19-.605.19-.54 0-.81-.244-.81-.732ZM58.776 63h-1.49v-5.459h1.49V63Zm6.455 0h-1.49v-3.188c0-.394-.066-.689-.2-.884-.13-.199-.336-.298-.62-.298-.38 0-.657.14-.83.42-.172.28-.258.74-.258 1.382V63h-1.49v-5.459h1.138l.2.698h.083c.147-.25.358-.446.635-.586.277-.143.594-.215.952-.215.817 0 1.37.267 1.66.801h.132c.147-.254.362-.45.645-.59.286-.14.608-.21.967-.21.618 0 1.085.159 1.401.478.319.316.478.824.478 1.523V63h-1.494v-3.188c0-.394-.066-.689-.2-.884-.13-.199-.337-.298-.62-.298-.364 0-.638.13-.82.39-.18.26-.269.674-.269 1.24V63Zm4.873-6.87c0-.485.27-.728.81-.728.541 0 .811.243.811.728 0 .231-.068.412-.205.542-.133.127-.335.19-.605.19-.54 0-.81-.244-.81-.732ZM71.658 63h-1.49v-5.459h1.49V63Zm5.366 0h-4.311v-.879l2.529-3.442h-2.378V57.54h4.072v.967l-2.46 3.354h2.548V63Zm3.345-4.502c-.316 0-.563.101-.742.303-.18.198-.282.482-.308.85h2.09c-.007-.368-.103-.652-.288-.85-.186-.202-.436-.303-.752-.303Zm.21 4.6c-.879 0-1.566-.243-2.06-.728-.496-.485-.743-1.172-.743-2.06 0-.915.228-1.622.684-2.12.459-.5 1.092-.752 1.9-.752.77 0 1.371.22 1.8.66.43.44.645 1.046.645 1.82v.724h-3.52c.016.423.142.753.376.99.234.238.563.357.986.357.329 0 .64-.034.933-.102.293-.069.599-.178.918-.327v1.152a3.42 3.42 0 0 1-.835.288 5.136 5.136 0 0 1-1.084.098Z" fill="currentColor"></path></g></g><path d="m67.34 73-7 7-7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path><defs><filter id="a" x="0" y="0" width="120" height="120" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="6"></feOffset><feGaussianBlur stdDeviation="10"></feGaussianBlur><feColorMatrix values="0 0 0 0 0.0751563 0 0 0 0 0.113891 0 0 0 0 0.4625 0 0 0 0.15 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3861_7231"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_3861_7231" result="shape"></feBlend></filter></defs></svg>`, 34);
var _tmpl$9 = /* @__PURE__ */ _$template(`<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m3.333 3.333 9.334 9.334M3.333 12.667l9.334-9.334" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>`, 4);
function createFloatingWidget({
  events
}, openWindow, renderIframe2, opts = {}) {
  const container = document.createElement("div");
  container.attachShadow({
    mode: "open"
  });
  const {
    attach
  } = getTwind();
  attach(container.shadowRoot);
  document.body.appendChild(container);
  const cleanup = render(() => _$createComponent(Container, {
    events,
    get verbose() {
      return opts.verbose;
    },
    get openWindow() {
      return opts.openInNewTab ? openWindow : void 0;
    },
    renderIframe: renderIframe2,
    get closeable() {
      return opts.closeable;
    },
    get defaultOpen() {
      return opts.defaultOpen;
    }
  }), container.shadowRoot);
  return () => {
    cleanup();
    document.body.removeChild(container);
  };
}
function Container(props) {
  const [open, setIsOpen] = createSignal(props.defaultOpen && !props.openWindow && "open" || "closed");
  if (props.openWindow && props.defaultOpen) {
    props.openWindow();
  }
  const isOpen = createMemo(() => open() === "open");
  const close = () => {
    setIsOpen("hidden");
  };
  const [closed, setClosed] = createSignal(false);
  const alwaysVisibleOnTouchDevice = () => tw(css({
    "&": {
      opacity: 1
    },
    "@media (hover: hover)": {
      "&": {
        opacity: 0
      }
    }
  }));
  return (() => {
    const _el$ = _tmpl$.cloneNode(true), _el$2 = _el$.firstChild;
    _el$2.$$click = () => {
      if (props.openWindow) {
        props.openWindow();
      } else {
        setIsOpen((x) => x === "open" ? "hidden" : "open");
      }
    };
    _$className(_el$2, tw`active:outline-none focus:outline-none outline-none self-end overflow-hidden pointer-events-auto`);
    _$insert(_el$2, _$createComponent(Floatie, {
      isOpen,
      get events() {
        return props.events;
      },
      get verbose() {
        return props.verbose;
      }
    }));
    _$insert(_el$, (() => {
      const _c$ = _$memo(() => open() !== "closed", true);
      return () => _c$() && _$createComponent(Talky, {
        isOpen,
        close,
        get verbose() {
          return props.verbose;
        },
        get renderIframe() {
          return props.renderIframe;
        }
      });
    })(), null);
    _$insert(_el$, (() => {
      const _c$2 = _$memo(() => !!(props.closeable && !isOpen()), true);
      return () => _c$2() && (() => {
        const _el$3 = _tmpl$2.cloneNode(true), _el$4 = _el$3.firstChild;
        _el$3.style.setProperty("box-shadow", "0px 3px 10px rgba(19, 29, 118, 0.1)");
        _el$4.$$click = () => setClosed(true);
        _$className(_el$4, tw`w-4 h-4 active:outline-none focus:outline-none outline-none overflow-hidden pointer-events-auto text-black hover:text-red-500`);
        _$insert(_el$4, _$createComponent(FloatingCloseButton, {}));
        _$effect(() => _$className(_el$3, tw(props.closeable && !props.verbose ? "bottom-[28px] right-[24px]" : "bottom-2 right-4 sm:right-0", "absolute top-auto w-8 h-8 flex items-center justify-center rounded-full bg-white transition duration-700 group-hover:opacity-100", alwaysVisibleOnTouchDevice())));
        return _el$3;
      })();
    })(), null);
    _$effect(() => _$className(_el$, tw(closed() ? "hidden" : "flex", "pointer-events-none", isOpen() ? "top-2 h-[98vh]" : "h-full bottom-0", "fixed sm:top-auto sm:bottom-0 right-0 flex-col-reverse w-full sm:h-auto sm:w-auto items-center group", props.verbose && "sm:mr-4 mb-4")));
    return _el$;
  })();
}
function Talky(props) {
  return (() => {
    const _el$5 = _tmpl$3.cloneNode(true);
    _$insert(_el$5, _$createComponent(Iframe, {
      get renderIframe() {
        return props.renderIframe;
      }
    }));
    _$effect(() => _$className(_el$5, tw("pointer-events-auto", props.isOpen() ? "flex flex-col" : "hidden", props.verbose ? "sm:h-[calc(60vh+30px)] sm:mr-2.5" : "-mb-[48px] sm:h-[calc(60vh+60px)] sm:mr-8", "z-10 shadow-md w-full h-full rounded-xl bg-white min-w-[340px] sm:min-w-[480px] max-w-[90vw] sm:max-h-screen")));
    return _el$5;
  })();
}
function Iframe(props) {
  let cleanup = () => {
  };
  return (() => {
    const _el$6 = _tmpl$3.cloneNode(true);
    ((el) => {
      if (el) {
        cleanup = props.renderIframe(el);
      } else {
        cleanup();
      }
    })(_el$6);
    _$effect(() => _$className(_el$6, tw("flex-1 rounded-xl overflow-hidden")));
    return _el$6;
  })();
}
function Floatie(props) {
  const [unreadCounter, setUnreadCount] = createSignal(props.events.unreadCount === void 0 ? 0 : props.events.unreadCount);
  props.events.on("fogbender.unreadCount", (e) => {
    setUnreadCount(e.unreadCount);
  });
  return props.verbose ? (() => {
    const _el$7 = _tmpl$4.cloneNode(true), _el$8 = _el$7.firstChild, _el$9 = _el$8.nextSibling, _el$10 = _el$9.nextSibling;
    _$className(_el$7, tw`w-36 mb-4 mr-7 sm:mr-2.5 py-2 px-4 flex items-center justify-center gap-x-2 rounded-full bg-white transform origin-bottom-right scale-75`);
    _el$7.style.setProperty("box-shadow", "0px 6px 20px rgba(19, 29, 118, 0.15)");
    _$insert(_el$8, _$createComponent(FloatingVerboseSvg, {}));
    _$className(_el$9, tw`text-left text-sm font-semibold`);
    _$className(_el$10, tw`absolute top-0 right-0 text-white rounded-full bg-brand-red-500 text-xs leading-none`);
    _$insert(_el$10, (() => {
      const _c$3 = _$memo(() => unreadCounter() === -1, true);
      return () => _c$3() ? "@" : unreadCounter();
    })());
    _$effect((_p$) => {
      const _v$ = unreadCounter() === 0 ? "none" : "block", _v$2 = unreadCounter() === -1 ? "2px 3px" : "2px 5px";
      _v$ !== _p$._v$ && _el$10.style.setProperty("display", _p$._v$ = _v$);
      _v$2 !== _p$._v$2 && _el$10.style.setProperty("padding", _p$._v$2 = _v$2);
      return _p$;
    }, {
      _v$: void 0,
      _v$2: void 0
    });
    return _el$7;
  })() : (() => {
    const _el$11 = _tmpl$5.cloneNode(true), _el$12 = _el$11.firstChild, _el$13 = _el$12.nextSibling, _el$14 = _el$13.nextSibling;
    _$insert(_el$12, _$createComponent(FloatingSvg, {}));
    _$insert(_el$13, _$createComponent(FloatingSvgOpened, {}));
    _$className(_el$14, tw`absolute text-white rounded-full bg-brand-red-500 text-xs leading-none`);
    _el$14.style.setProperty("top", "20px");
    _el$14.style.setProperty("left", "78px");
    _$insert(_el$14, (() => {
      const _c$4 = _$memo(() => unreadCounter() === -1, true);
      return () => _c$4() ? "@" : unreadCounter();
    })());
    _$effect((_p$) => {
      const _v$3 = tw("relative w-32 h-32"), _v$4 = tw("absolute inset-0"), _v$5 = tw("absolute inset-0 duration-300", props.isOpen() ? "opacity-100" : "opacity-0"), _v$6 = unreadCounter() === 0 ? "none" : "block", _v$7 = unreadCounter() === -1 ? "2px 3px" : "2px 5px";
      _v$3 !== _p$._v$3 && _$className(_el$11, _p$._v$3 = _v$3);
      _v$4 !== _p$._v$4 && _$className(_el$12, _p$._v$4 = _v$4);
      _v$5 !== _p$._v$5 && _$className(_el$13, _p$._v$5 = _v$5);
      _v$6 !== _p$._v$6 && _el$14.style.setProperty("display", _p$._v$6 = _v$6);
      _v$7 !== _p$._v$7 && _el$14.style.setProperty("padding", _p$._v$7 = _v$7);
      return _p$;
    }, {
      _v$3: void 0,
      _v$4: void 0,
      _v$5: void 0,
      _v$6: void 0,
      _v$7: void 0
    });
    return _el$11;
  })();
}
function FloatingVerboseSvg() {
  return _tmpl$6.cloneNode(true);
}
function FloatingSvg() {
  return _tmpl$7.cloneNode(true);
}
function FloatingSvgOpened() {
  return (() => {
    const _el$17 = _tmpl$8.cloneNode(true);
    _$setAttribute(_el$17, "class", tw`text-black fill-white hover:text-white hover:fill-blue-500 transition-colors`);
    return _el$17;
  })();
}
function FloatingCloseButton() {
  return _tmpl$9.cloneNode(true);
}
_$delegateEvents(["click"]);

// src/renderUnreadBadge.tsx
init_esm_shims();
import { template as _$template2 } from "solid-js/web";
import { delegateEvents as _$delegateEvents2 } from "solid-js/web";
import { effect as _$effect2 } from "solid-js/web";
import { insert as _$insert2 } from "solid-js/web";
import { memo as _$memo2 } from "solid-js/web";
import { className as _$className2 } from "solid-js/web";
import { addEventListener as _$addEventListener } from "solid-js/web";
import { render as render2 } from "solid-js/web";
import { createSignal as createSignal2 } from "solid-js";
import { tw as tw2 } from "twind";
var _tmpl$10 = /* @__PURE__ */ _$template2(`<button></button>`, 2);
var _tmpl$22 = /* @__PURE__ */ _$template2(`<span>@</span>`, 2);
var _tmpl$32 = /* @__PURE__ */ _$template2(`<span></span>`, 2);
function renderUnreadBadge({
  events
}, openWindow, {
  el
}) {
  const {
    attach
  } = getTwind();
  if (el.shadowRoot) {
    el.shadowRoot.innerHTML = "";
  } else {
    el.attachShadow({
      mode: "open"
    });
    attach(el.shadowRoot);
  }
  const x = render2(() => {
    const [unreadCounter, setUnreadCounter] = createSignal2(events.unreadCount);
    events.on("fogbender.unreadCount", (e) => {
      setUnreadCounter(e.unreadCount);
    });
    return (() => {
      const _el$ = _tmpl$10.cloneNode(true);
      _$addEventListener(_el$, "click", openWindow, true);
      _$className2(_el$, tw2`hidden min-w-1rem min-h-1rem items-center justify-center bg-brand-red-500 rounded-full text-white text-2xs font-bold leading-none`);
      _$insert2(_el$, (() => {
        const _c$ = _$memo2(() => unreadCounter() === -1, true);
        return () => _c$() ? (() => {
          const _el$2 = _tmpl$22.cloneNode(true);
          _$className2(_el$2, tw2`text-xs`);
          return _el$2;
        })() : (() => {
          const _el$3 = _tmpl$32.cloneNode(true);
          _$className2(_el$3, tw2`px-1`);
          _$insert2(_el$3, unreadCounter);
          return _el$3;
        })();
      })());
      _$effect2(() => _el$.style.setProperty("display", !unreadCounter() || unreadCounter() === 0 ? "none" : "flex"));
      return _el$;
    })();
  }, el.shadowRoot);
  return () => {
    x();
    el.innerHTML = "";
  };
}
_$delegateEvents2(["click"]);

// src/index.ts
var createNewFogbender = () => {
  const defaultUrl = "https://client.fogbender.com";
  const state = {
    versions: {},
    env: void 0,
    token: void 0,
    url: defaultUrl,
    iframe: void 0,
    events: createEvents(),
    chatWindow: null
  };
  const openWindow = () => {
    var _a2;
    if (!state.chatWindow || state.chatWindow.closed) {
      state.chatWindow = window.open(
        state.url + "?token=" + encodeURIComponent(JSON.stringify(state.token)),
        "_blank"
      );
    }
    (_a2 = state.chatWindow) == null ? void 0 : _a2.focus();
  };
  const updateConfigured = () => {
    const configured = !!state.url && !!state.token;
    state.events.configured = configured;
    state.events.emit("configured", configured);
  };
  const fogbender = {
    _privateData: state,
    async setVersion(tag, version) {
      state.versions[tag] = version;
      return fogbender;
    },
    async setEnv(env) {
      state.env = env;
      return fogbender;
    },
    async setClientUrl(_url) {
      state.url = _url === void 0 ? defaultUrl : _url;
      updateConfigured();
      return fogbender;
    },
    async setToken(token) {
      const tokenCheck = checkToken(token);
      if (tokenCheck) {
        throw new Error("Wrong token format:\n" + JSON.stringify(tokenCheck, null, 1));
      }
      state.token = token;
      if (state.token) {
        state.token = {
          ...state.token,
          versions: { ...state.token.versions, ...state.versions, fogbender: "0.2.1" }
        };
      }
      updateConfigured();
      return fogbender;
    },
    async isClientConfigured() {
      const snapshot = {
        getValue: () => state.events.configured,
        subscribe: (cb) => {
          cb(state.events.configured);
          return state.events.on("configured", cb);
        }
      };
      return snapshot;
    },
    async createFloatingWidget(opts = {}) {
      if (!state.url) {
        throw new Error("Fogbender: no url given");
      }
      if (!state.token) {
        throw new Error("Fogbender: no token given");
      }
      const { token, url, env } = state;
      const cleanup = createFloatingWidget(
        state,
        openWindow,
        (el) => renderIframe(state, { rootEl: el, env, token, url, disableFit: true }, openWindow),
        opts
      );
      return cleanup;
    },
    async renderIframe(opts) {
      if (!state.url) {
        throw new Error("Fogbender: no url given");
      }
      if (!state.token) {
        throw new Error("Fogbender: no token given");
      }
      const cleanup = renderIframe(
        state,
        { ...opts, env: state.env, token: state.token, url: state.url },
        openWindow
      );
      return cleanup;
    },
    async renderUnreadBadge(opts) {
      const cleanup = renderUnreadBadge(state, openWindow, opts);
      return cleanup;
    }
  };
  return fogbender;
};
export {
  checkToken,
  createNewFogbender,
  isUserToken
};
//# sourceMappingURL=index.js.map